const createPeCarouselImages = trim => {
  // PE alternate primary image
  const alternateImage = [
    {
      url: trim?.primaryImage?.src,
      alt: {
        value: trim?.primaryImage?.alt,
      },
    },
  ];

  const carouselImages = trim?.studioAssets?.images || alternateImage;

  // TODO: check placeholder image for PE
  const missingAssetPlaceholderImage = {
    url: trim?.primaryImage?.src,
    alt: {
      value: trim?.primaryImage?.alt,
    },
  };

  const hasImages = carouselImages && carouselImages.length > 0;

  return { carouselImages, hasImages, missingAssetPlaceholderImage };
};

export default createPeCarouselImages;
